import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { configureStore, combineReducers } from "@reduxjs/toolkit";

import AccessKeysSlice from "./slices/AccessKeysSlice";
import AuthSlice from "./slices/AuthSlice";
import ChatBotsSlice from "./slices/ChatBotsSlice";
import DomSlice from "./slices/DomSlice";
import LLMSlice from "./slices/LLMSlice";
import SelectedAgentSlice from "./slices/SelectedAgentSlice";
import ToolSlice from "./slices/ToolSlice";
import UserSlice from "./slices/UserSlice";

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['chatBots',"users","selectedAgent","accessKeys"]
}

const rootReducer = combineReducers({
    chatBots: ChatBotsSlice,
    user: AuthSlice,
    dom: DomSlice,
    selectedAgent: SelectedAgentSlice,
    llm: LLMSlice,
    tools: ToolSlice,
    users: UserSlice,
    accessKeys: AccessKeysSlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
});

export const persistedStore = persistStore(store)

